import React, { useState } from "react";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../../components/common-components/CommonHeadingNBtns";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { earningTaskSchema } from "../../../schema/schema";
import { updateEarningTask } from "../../../data/ApiEndpoints";

const EarningUpdateForm = ({
  initialValues,
  isEdit,
  closeModal,
  token,
  getEarningTasks,
}) => {
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: earningTaskSchema,
    onSubmit: async (values) => {
      const method = "PUT";
      const endpoint = updateEarningTask;

      const payload = { ...initialValues, value: values?.value };

      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        getEarningTasks();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    },
  });

  return (
    <div className="createNewCTOModalContainer mod-width-70p">
      <CommonHeadingNBtns
        title="Edit Earning Task"
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        btnTxt={isEdit ? "Update" : "Save"}
        onClose={closeModal}
      />

      <form className="formContainer" onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label>
              Task Name
              <span className="text-danger">*</span>
            </label>
            <div className="commonWrapper dropdownCommonWrapper">
              <input
                type="text"
                name="reference"
                style={{
                  width: "100%",
                  height: "100%",
                  padding: "10px",
                  fontWeight: "500",
                }}
                placeholder="Task Name"
                value={formik.values.reference}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={true}
              />
            </div>
            {formik.touched.reference && formik.errors.reference ? (
              <div className="error-message">{formik.errors.reference}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label>
              Coins Reward
              <span className="text-danger">*</span>
            </label>
            <div className="commonWrapper dropdownCommonWrapper">
              <input
                type="number"
                name="value"
                style={{
                  width: "100%",
                  height: "100%",
                  padding: "10px",
                  fontWeight: "500",
                }}
                placeholder="Coins Reward"
                value={formik.values.value}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.value && formik.errors.value ? (
              <div className="error-message">{formik.errors.value}</div>
            ) : null}
          </div>
        </div>
      </form>
    </div>
  );
};

export default EarningUpdateForm;
